export const FETCH_SORTED_PARTNER_LIST_REQUEST = "FETCH_SORTED_PARTNER_LIST_REQUEST";
export const FETCH_SORTED_PARTNER_LIST_RESPONSE = "FETCH_SORTED_PARTNER_LIST_RESPONSE";
export const ALLOCATE_PARTNER_DATA_TO_SERVER_REQUEST = "ALLOCATE_PARTNER_DATA_TO_SERVER_REQUEST";
export const ALLOCATE_PARTNER_DATA_TO_SERVER_RESPONSE = "ALLOCATE_PARTNER_DATA_TO_SERVER_RESPONSE";
export const FETCH_ALLOCATED_PARTNER_DATA_REQUEST = "FETCH_ALLOCATED_PARTNER_DATA_REQUEST";
export const FETCH_ALLOCATED_PARTNER_DATA_RESPONSE = "FETCH_ALLOCATED_PARTNER_DATA_RESPONSE";
export const SEARCH_COUNTERPARTY_REQUEST = "SEARCH_COUNTERPARTY_REQUEST";
export const SEARCH_COUNTERPARTY_RESPONSE = "SEARCH_COUNTERPARTY_RESPONSE";
export const FETCH_ALLOCATED_SEARCH_COUNTERPARTY_REQUEST = "FETCH_ALLOCATED_SEARCH_COUNTERPARTY_REQUEST";
export const FETCH_PARTNER_PRODUCT_LIST_REQUEST = "FETCH_PARTNER_PRODUCT_LIST_REQUEST";
export const FETCH_PARTNER_PRODUCT_LIST_RESPONSE = "FETCH_PARTNER_PRODUCT_LIST_RESPONSE";
export const FETCH_PARTNER_ORDER_DATA_REQUEST = "FETCH_PARTNER_ORDER_DATA_REQUEST";
export const FETCH_PARTNER_ORDER_DATA_RESPONSE = "FETCH_PARTNER_ORDER_DATA_RESPONSE";
export const UPDATE_ADDITIONAL_DETAILS_REQUEST = "UPDATE_ADDITIONAL_DETAILS_REQUEST";
export const UPDATE_ADDITIONAL_DETAILS_RESPONSE = "UPDATE_ADDITIONAL_DETAILS_RESPONSE";
export const REALLOCATE_PARTNER_DATA_SERVER_REQUEST = "REALLOCATE_PARTNER_DATA_SERVER_REQUEST";
export const REALLOCATE_PARTNER_DATA_SERVER_RESPONSE = "REALLOCATE_PARTNER_DATA_SERVER_RESPONSE";

export const fetchSortedPartnerListRequest = (data) => {
    return {
        type: FETCH_SORTED_PARTNER_LIST_REQUEST,
        data
    }
}

export const fetchSortedPartnerListResponse = (data) => {
    return {
        type: FETCH_SORTED_PARTNER_LIST_RESPONSE,
        data
    }
}

export const allocatePartnerDataToServerRequest = (data) => {
    return {
        type: ALLOCATE_PARTNER_DATA_TO_SERVER_REQUEST,
        data
    }
}

export const allocatePartnerDataToServerResponse = (data) => {
    return {
        type: ALLOCATE_PARTNER_DATA_TO_SERVER_RESPONSE,
        data
    }
}

export const fetchAllocatedPartnerDataRequest = (data) => {
    return {
        type: FETCH_ALLOCATED_PARTNER_DATA_REQUEST,
        data
    }
}

export const fetchAllocatedPartnerDataResponse = (data) => {
    return {
        type: FETCH_ALLOCATED_PARTNER_DATA_RESPONSE,
        data
    }
}

export const searchCounterpartyRequest = (data) => {
    return {
        type: SEARCH_COUNTERPARTY_REQUEST,
        data
    }
}

export const searchCounterpartyResponse = (data) => {
    return {
        type: SEARCH_COUNTERPARTY_RESPONSE,
        data
    }
}

export const fetchAllocatedSearchDataRequest = (data) => {
    return {
        type: FETCH_ALLOCATED_SEARCH_COUNTERPARTY_REQUEST,
        data
    }
}

export const fetchPartnerProductListRequest = (data) => {
    return {
        type: FETCH_PARTNER_PRODUCT_LIST_REQUEST,
        data
    }
}

export const fetchPartnerProductListResponse = (data) => {
    return {
        type: FETCH_PARTNER_PRODUCT_LIST_RESPONSE,
        data
    }
}

export const fetchPartnerOrderDataRequest = (data) => {
    return {
        type: FETCH_PARTNER_ORDER_DATA_REQUEST,
        data
    }
}

export const fetchPartnerOrderDataResponse = (data) => {
    return {
        type: FETCH_PARTNER_ORDER_DATA_RESPONSE,
        data
    }
}

export const upadateAdditinalDetailsRequest = (data) => {
    return {
        type: UPDATE_ADDITIONAL_DETAILS_REQUEST,
        data
    }
}

export const upadateAdditinalDetailsResponse = (data) => {
    return {
        type: UPDATE_ADDITIONAL_DETAILS_RESPONSE,
        data
    }
}

export const reallocatePartnerRequest = (data) => {
    return {
        type: REALLOCATE_PARTNER_DATA_SERVER_REQUEST,
        data
    }
}

export const reallocatePartnerResponse = (data) => {
    return {
        type: REALLOCATE_PARTNER_DATA_SERVER_RESPONSE,
        data
    }
}